export default "__VITE_ASSET__48f9a5d2__"